import { createBrowserRouter } from "react-router-dom";
import {
  CLIENT_MANAGE,
  ENTRY,
  PROTECTED,
  MANAGE_SELLERS_AND_STORES,
  DISPUTE,
  USER,
  POINT,
  INVOICE,
  ACCESS_RIGHT,
  KYC_APPROVAL,
  SUBSCRIPTION_APPROVAL,
  MANAGE_USERS_AND_BUYERS,
} from "./constants/urls";
import authRoutes from "./pages/auth/AuthRoutes";
import AppErrorBoundary from "./AppErrorBoundary";
import clientRoutes from "./pages/client/ClientRoutes";
import PointRoutes from "pages/point/PointRoutes";
import InvoiceRoutes from "pages/invoice/InvoiceRoutes";
import DisputeRoutes from "pages/dispute/DisputeRoutes";
import AccessRightRoutes from "./pages/access-right/AccessRightRoutes";
import AccessRightAndPermissionRoutes from "./pages/accessRightsAndPermissions/AccessRightRoutes";
import ManageSellerAndStoreRoutes from "./pages/manage-seller-and-store/ManageSellerAndStoreRoutes";
import UserManagementRoutes from "pages/user-management/UserManagementRoutes";
import KycApprovalRoutes from "pages/kyc-approval/KycApprovalRoutes";
import SubscriptionApprovalRoutes from "pages/subscription-approval/SubscriptionApprovalRoutes";
import ManageUsersAndBuyersRoutes from "pages/manage-users-and-buyers/ManageUsersAndBuyersRoutes";
import reportRoutes from "./pages/report/ReportRoutes";
import thirdPartyBusinessesRoutes from "./pages/third-party-businesses/ThirdPartyBusinessesRoutes";
import deliveryPricingRoutes from "./pages/delivery-pricing/DeliveryPricingRoutes";

const router = createBrowserRouter([
  {
    path: ENTRY,
    lazy: () => import("./App"),
    ErrorBoundary: AppErrorBoundary,
    children: [
      {
        lazy: () => import("./AppPublic"),
        children: [
          {
            lazy: () => import("./pages/auth/Auth"),
            children: authRoutes,
          },
        ],
      },
      {
        path: PROTECTED,
        lazy: () => import("./AppProtected"),
        children: [
          {
            path: PROTECTED,
            lazy: () => import("./pages/admin-console/routes/AdminConsole"),
          },
          {
            path: CLIENT_MANAGE,
            lazy: () => import("./pages/client/Client"),
            children: clientRoutes,
          },
          {
            path: MANAGE_SELLERS_AND_STORES,
            lazy: () =>
              import("./pages/manage-seller-and-store/ManageSellerAndStore"),
            children: ManageSellerAndStoreRoutes,
          },
          {
            path: MANAGE_USERS_AND_BUYERS,
            lazy: () =>
              import("./pages/manage-users-and-buyers/ManageUsersAndBuyers"),
            children: ManageUsersAndBuyersRoutes,
          },
          {
            path: POINT,
            lazy: () => import("./pages/point/Point"),
            children: PointRoutes,
          },
          {
            path: INVOICE,
            lazy: () => import("./pages/invoice/Invoice"),
            children: InvoiceRoutes,
          },
          {
            path: DISPUTE,
            lazy: () => import("./pages/dispute/Dispute"),
            children: DisputeRoutes,
          },
          {
            path: ACCESS_RIGHT,
            lazy: () => import("./pages/access-right/AccessRight"),
            children: AccessRightRoutes,
          },
          {
            lazy: () =>
              import("./pages/accessRightsAndPermissions/AccessRight"),
            children: AccessRightAndPermissionRoutes,
          },
          {
            path: USER,
            lazy: () => import("./pages/user-management/UserManagement"),
            children: UserManagementRoutes,
          },
          {
            path: KYC_APPROVAL,
            lazy: () => import("./pages/kyc-approval/KycApproval"),
            children: KycApprovalRoutes,
          },
          {
            path: SUBSCRIPTION_APPROVAL,
            lazy: () =>
              import("./pages/subscription-approval/SubscriptionApproval"),
            children: SubscriptionApprovalRoutes,
          },
          {
            lazy: () => import("./pages/report/Report"),
            children: reportRoutes,
          },
          {
            lazy: () =>
              import("./pages/third-party-businesses/ThirdPartyBusinesses"),
            children: thirdPartyBusinessesRoutes,
          },
          {
            lazy: () => import("./pages/delivery-pricing/DeliveryPricing"),
            children: deliveryPricingRoutes,
          },
        ],
      },
    ],
  },
]);

export default router;
